import { render, staticRenderFns } from "./NetworkTask.vue?vue&type=template&id=09328bbe&scoped=true"
import script from "./NetworkTask.vue?vue&type=script&lang=js"
export * from "./NetworkTask.vue?vue&type=script&lang=js"
import style0 from "./NetworkTask.vue?vue&type=style&index=0&id=09328bbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09328bbe",
  null
  
)

export default component.exports